/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Status_FailedInputs */

const vi_cdo_status_failed = /** @type {(inputs: Cdo_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao thất bại`)
};

/**

* @param {Cdo_Status_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_status_failed = /** @type {((inputs?: Cdo_Status_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Status_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_status_failed(inputs)
});